import { initVolumeObject } from '@/containers/CampaignDetail/AffectedVehicles/SeriesPanel/SeriesRow/series-row-utils';

export const uniqueSeriesPlants = (series = []) => {
  const allPlants = series.flatMap((plant) => Object.values(plant?.typeVersions ?? {}).flat());
  const plantsMap = allPlants.reduce((plants, plant) => ({ ...plants, [plant.wkzNumber]: plant }), {});
  const filteredPlants = Object.keys(plantsMap).reduce((plants, wkzNumber) => [...plants, plantsMap[wkzNumber]], []);
  filteredPlants.sort((a, b) => (a.plantName.toLowerCase() < b.plantName.toLowerCase() ? -1 : 1));

  return filteredPlants;
};

export const addPlantsNotInVolumes = (volumes, plants, activeLanguages, typeOfSelection) => plants
  .reduce((prev, currentPlant) => {
    const foundVolume = volumes.find(({ plant }) => plant === currentPlant.wkzNumber);

    if (foundVolume) {
      foundVolume.fileOptionSelected = typeOfSelection === 'PLANTS' || foundVolume.fileOptionSelected;

      return prev.map((volume) => (volume.plant === currentPlant.wkzNumber ? foundVolume : volume));
    }

    prev.push(initVolumeObject(currentPlant, activeLanguages, typeOfSelection));

    return prev;
  }, [...volumes]);
